import debug from "debug";
const log = debug("hover-label");

class HoverLabel {
	constructor(element, options) {
		this.element = element;
		this.options = options;
        log(
            element,options
        );

		if (!this.options.boxSelector) {
			log(
				'No box selector provided for this instance. Add a selector with data-hover-label-box-selector="...". Aborting.',
				element
			);
			return false;
		}

		this.box = document.querySelector(this.options.boxSelector);

		if (!this.box) {
			log(
				`No element found matching the provided data-hover-label-box-selector="${this.options.boxSelector} Aborting.`,
				element
			);
			return false;
		}

		if (!this.options.textSelector) {
			log(
				'No text element selector provided for this instance. Add a selector with data-hover-label-text-selector="..." Aborting.',
				element
			);
			return false;
		}

		this.labelTextElement = this.element.querySelector(
			this.options.textSelector
		);

		if (!this.labelTextElement) {
			log(
				`No element found matching the provided data-hover-label-text-selector="${this.options.textSelector}" Aborting.`,
				element
			);
			return false;
		}

		this.labelText = this.labelTextElement.textContent;

		if (this.labelText.trim() === "") {
			log(
				'No text found in element found with data-hover-label-text-selector="${this.options.textSelector}" Aborting.',
				element
			);
			return false;
		}

		// log(element, options);
		this.watch();
	}

	watch() {
		this.element.addEventListener(
			"mouseenter",
			this.hoverHandler.bind(this)
		);
		this.element.addEventListener(
			"mouseleave",
			this.unhoverHandler.bind(this)
		);
	}
	hoverHandler() {
		const labelMargin = 6;

		// remove transform from box
		this.box.style.transform = null;
		this.box.style.top = null;
		this.box.style.left = null;

		// populate box with label text
		this.box.textContent = this.labelText;

		if (this.options.showBoxClass) {
			this.box.classList.add(this.options.showBoxClass);
		} else {
			this.box.hidden = false;
		}

		const boxRect = this.box.getBoundingClientRect();
		const positionContextRect = this.box.offsetParent.getBoundingClientRect();

		// get rect of hovered item
		const targetRect = this.element.getBoundingClientRect();

		// calc left pos of center of hovered item
		const targetCenter =
			targetRect.left - positionContextRect.left + targetRect.width / 2;

		// calc left position of box to center with hovered
		// substract half box width for left pos of box
		const boxLeft = targetCenter - boxRect.width / 2;
		const boxTop =
			targetRect.top -
			positionContextRect.top +
			targetRect.height +
			labelMargin;

		// apply box position
		this.box.style.top = `${boxTop}px`;

		// avoid setting value less than 0
		this.box.style.left = `${Math.max(boxLeft, 0)}px`;

		// display box ?

		// intersection observer with viewport
		// apply transform to avoid clipping on left/right
	}

	unhoverHandler() {
		// empty text from box
		this.box.textContent = '';

		if (this.options.showBoxClass) {
			this.box.classList.remove(this.options.showBoxClass);
		} else {
			this.box.hidden = true;
		}
	}
}

HoverLabel.DEFAULTS = {};

export default HoverLabel;



// WEBPACK FOOTER //
// ./project/client/src/core/modules/hover-label/hover-label.js